import * as ActionTypes from 'actions/ActionTypes'

export const changeSplitSize = ({ value, type }) => ({
  type: ActionTypes.CHANGE_SPLIT_SIZE,
  payload: {
    value,
    type,
  },
})

export const setResizing = (resizing, resizer = null) => ({
  type: ActionTypes.SET_RESIZING,
  payload: { resizing, resizer },
})

export const setUIElementDisplayType = (type, element) => ({
  type: ActionTypes.SET_UI_ELEMENT_DISPLAY_TYPE,
  payload: { type, element },
})

export const setActiveInteractionUIElement = activeUIElement => ({
  type: ActionTypes.SET_ACTIVE_INTERACTION_UI_ELEMENT,
  payload: { activeUIElement },
})

export const setUIElementBounds = (uiElement, bounds) => ({
  type: ActionTypes.SET_UI_ELEMENT_BOUNDS,
  payload: { uiElement, bounds },
})
